module.exports = __webpack_public_path__ + "static/media/jijin.dda92bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/jijin.png
// module id = 2172
// module chunks = 0